import { Defaults } from 'es-decorators'
import { View } from 'es6/components/view'
import { getTemplate } from 'helpers/template-helper'
import {
  roundFloatPointNum,
  numberWithoutZeroFraction,
} from 'helpers/number-helpers'
import { currentCurrency } from 'init/current-currency'
import { CartItem } from 'es6/models/cart-item'
import { RecommendationsItemQtyView } from './recommendations-item-qty-view'
import $ from 'init/jquery'
import { isMobile } from 'init/is-mobile'
import Backbone from 'init/backbone'
import { RecommendationsFlagsView } from './recommendations-flags-view'

/**
 * Карточка рекомендованного товара
 */
@Defaults({
  el: '.recommendations-item',
  model: '',
  sid: '',
  /*
   * Тип кнопки:
   *
   * hide - 'Не интересно'
   * show - 'Отменить'
   */
  hideType: {
    hide: 1,
    show: 0,
  },
  recommendationsPriceTemplateId: '#recommendations-price-template',
  events: {
    'click .product__image': 'triggerRecommendationsEvent',
    'click .product__name': 'triggerRecommendationsEvent',
    'click .button_add2cart': 'triggerRecommendationsEvent',
    'click .disinterest': 'hideNotInterestedItem',
    'click .js-cancel-disinterest': 'showInterestedItem',
  },
  additionalOptions: ['recommendationsEvents', 'algo', 'sid', 'isCart'],
})
export class RecommendationsItemView extends View {
  /**
   * @inheritDoc
   */
  run () {
    this.buttonInit()
    this.addTitle()
    this.refreshPrice()
    this.rewritePageLinks()
    this.renderFlags()
  }

  /**
   * Обновляет элемент(ы) вью рекоммендации.
   * @param {jQuery} el Элемент(ы) рекоммендованного товара вместе с клонированными.
   */
  refreshElement (el) {
    this.setElement(el)
    const qtyView = this.childViews.qtyView
    const buttonsBlock = this.$('.btn-block')
    if (qtyView) {
      qtyView.setElement(buttonsBlock)
    }
  }

  /**
   * Рендер шильдиков.
   */
  renderFlags () {
    if (this.$('.flags').length) {
      this.childViews.flagsView = new RecommendationsFlagsView({
        el: this.$('.flags'),
      })
    }
  }

  /**
   * Ререндер цены, если она не актуальна.
   */
  refreshPrice () {
    let oldPrice = parseFloat(
        this.$('.recommendations-item-oldprice .price__val span').first().html()
        + '.' + this.$('.recommendations-item-oldprice .price__val sup').html()),
      price = parseFloat(
        this.$('.recommendations-item-price .price__val span').first().html()
        + '.' + this.$('.recommendations-item-price .price__val sup').html()),
      modelOldPrice = this.model.get('price_max'),
      modelPrice = this.model.get('price'),
      needRender = false

    if ($('.layout').data('jsview') === 'product') {
      oldPrice = parseFloat(this.$('.recommendations-item-oldprice .price__val').text()) / 100
      price = parseFloat(this.$('.recommendations-item-price .price__val').text()) / 100
    }
    if (oldPrice && oldPrice !== modelOldPrice) {
      oldPrice = modelOldPrice
      needRender = true
    }
    if (price !== modelPrice && modelPrice) {
      price = modelPrice
      needRender = true
    }
    if (isNaN(oldPrice) && this.model.get('has_discount') === 1) {
      oldPrice = this.model.get('price_max')
    }
    if (this.model.get('has_custom_qty_units')) {
      let inSet = this.model.get('in_set')
      price = roundFloatPointNum(price / inSet)
      oldPrice = roundFloatPointNum(oldPrice / inSet)
      needRender = true
    }
    if (needRender) {
      let template = getTemplate(this.recommendationsPriceTemplateId)
      this.$('.price-block').html(template({
        price: numberWithoutZeroFraction(price),
        oldprice: oldPrice ? numberWithoutZeroFraction(oldPrice) : null,
        currentCurrency: currentCurrency.sign,
        pricePostfix: this.model.get('is_weighted_goods') ? ' / кг' : '',
      }))
    }
  }

  /**
   * Кнопка корзины
   */
  buttonInit () {
    let model = this.model.get('cart_item') ? this.model.get('cart_item') : null
    this.childViews.qtyView = new RecommendationsItemQtyView({
      el: this.$('.btn-block'),
      item: this.model,
      model: new CartItem(model, { item: this.model }),
      cart: this.cart,
      settlement: this.settlement,
      user: this.user,
      template: isMobile && '.btn-template',
      isCart: this.isCart,
    })
  }

  /**
   * Добавление в атрибут title имени товара
   */
  addTitle () {
    this.$el.find('.product__detail a').attr('title', this.$el.find('.recommendations-item-title').text())
  }

  /**
   * Триггерит событие в recommendationsEvents для GTM
   * @param {Event} e
   */
  triggerRecommendationsEvent (e) {
    let $target = $(e.currentTarget)
    if (!this.recommendationsEvents) {
      return
    }
    if ($target.hasClass('product__image')) {
      this.recommendationsEvents.trigger('clickItemImgRecommendation')
    }
    if ($target.hasClass('product__name')) {
      this.recommendationsEvents.trigger('clickItemNameRecommendation')
    }
    if ($target.hasClass('button_add2cart')) {
      this.recommendationsEvents.trigger('clickItemButtonRecommendation')
    }
  }

  /**
   * Спрятать товар, если кликнули по ссылке "Не интересно"
   */
  hideNotInterestedItem () {
    this.$('.recommendations-item-container').hide()
    this.$('.disinterest-item').removeClass('not_display')
    this.pushOko(this.hideType.hide)
  }

  /**
   * Показать отключенный товар
   */
  showInterestedItem () {
    this.$('.recommendations-item-container').show()
    this.$('.disinterest-item').addClass('not_display')
    this.pushOko(this.hideType.show)
  }

  /**
   * Триггерит событие для око при скрытии/показе рекомендованного товара
   * @param {number} type Тип кнопки 'Не интересно'/'Отменить'
   */
  pushOko (type) {
    let data = {
      algo: this.algo,
      sid: this.model.get('sid'),
      type,
    }
    Backbone.trigger('recommendationsItem:hideItem', data)
  }
}
